import PropTypes from 'prop-types';
import React from 'react';
import { i18n } from '@international/mastodon-i18n';
import T from 'components/T';
import { M } from '@dashboard-experience/mastodon';
import Panel from '../../../Panels';
import { formatDateWithTimezone } from '../../../../lib/helpers';
import styles from './DrugAlcoholClearinghouse.module.css';
import withNonCanceledSearch from './WithNonCanceledSearch';
import { DrugAlcoholClearinghouseObject } from '../../../../types/report';

interface DrugAlcoholClearinghouseProps {
  search: DrugAlcoholClearinghouseObject;
}
const DrugAlcoholClearinghouse = ({
  search,
}: DrugAlcoholClearinghouseProps) => (
  <Panel
    data-testid='drug-alcohol-clearinghouse'
    title={i18n.getStr('components.drugAlcoholClearinghouse.title')}
    status={search.status}
  >
    {search.completedAt && (
      <div>
        <T value='components.drugAlcoholClearinghouse.description' />
        <span className='text-very-muted pl-2'>
          {formatDateWithTimezone(search.completedAt)}
        </span>
      </div>
    )}
    <M.Grid className='mt-3 mb-2'>
      {search.queryType && (
        <M.GridRow className='mb-1'>
          <M.GridCol sm={4} md={2} className='text-very-muted'>
            <T value='components.drugAlcoholClearinghouse.queryType' />
          </M.GridCol>
          <M.GridCol sm={8} md={6} data-testid='query-type'>
            {i18n.getStr(
              `components.drugAlcoholClearinghouse.queryTypes.${search.queryType}`,
            )}
          </M.GridCol>
        </M.GridRow>
      )}

      {search.queryResult && (
        <M.GridRow className='mb-1'>
          <M.GridCol sm={4} md={2} className='text-very-muted'>
            <T value='components.drugAlcoholClearinghouse.queryResult' />
          </M.GridCol>
          <M.GridCol sm={8} md={6}>
            {search.queryResult}
          </M.GridCol>
        </M.GridRow>
      )}

      {search.queryDetailsDocument && (
        <M.GridRow className='mb-1'>
          <M.GridCol sm={4} md={2} className='text-very-muted'>
            <T value='components.drugAlcoholClearinghouse.queryDetails' />
          </M.GridCol>
          <M.GridCol sm={8} md={6}>
            <a
              href={search.queryDetailsDocument.downloadUri}
              target='_blank'
              rel='noreferrer'
            >
              {search.queryDetailsDocument.filename}
            </a>
          </M.GridCol>
        </M.GridRow>
      )}
    </M.Grid>

    <div className={styles.styled} data-testid='disclaimer'>
      {i18n.renderHTML('components.drugAlcoholClearinghouse.disclaimer')}
    </div>
  </Panel>
);

DrugAlcoholClearinghouse.propTypes = {
  search: PropTypes.object,
};

DrugAlcoholClearinghouse.defaultProps = {
  search: {},
};

// @ts-ignore
export default withNonCanceledSearch(DrugAlcoholClearinghouse);
